import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Direction } from '../../types/direction';

@Component({
  selector: 'app-be-tooltip',
  imports: [NgClass],
  templateUrl: './be-tooltip.component.html',
  styleUrls: ['./be-tooltip.component.scss'],
})
export class BeTooltipComponent {
  @Input() direction: Direction = 'down';
  @Input() variant: 'default' | 'hero' = 'default';
}
